import { PointDto } from 'api/dtos/point';
import { TagDto } from 'api/dtos/tag';
import { ThemeMode } from 'api/dtos/theme';
import { InvoiceDetailsDto } from 'api/dtos/invoiceDetailsDtos';

export enum UserRole {
    Owner,
    Admin,
    Moderator,
    TeamMember,
    Guest
}

export interface UserShortEntityDto {
  id: string;
  name: string;
  role: UserRole;
  parentId?: string | null;
  parentName?: string;
  isParish: boolean;
  usesPoints: boolean;
  isIndependent: boolean;
  canCreateGroups?: boolean;
}

export interface AccountAddressDto {
  street: string;
  buildingNumber: string;
  apartmentNumber?: string | null;
  postalCode: string;
  city: string;
  country: string;
}

export interface UserDto {
  id: string;
  firstName: string;
  lastName: string;
  dateOfBirth?: string;
  email: string;
  phoneNumber?: string;
  themeMode: ThemeMode;
  subscriptionPlanId: string;
  entities: UserShortEntityDto[];
  points: PointDto[];
  tags: TagDto[];
  address?: AccountAddressDto | null;
  invoiceDetails?: InvoiceDetailsDto | null;
  hasInitialSetupCompleted: boolean;
}
